import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "@/components/ui/dialog";
import { ModalPanel } from "@/components/ui/modal-panel";
import type { Task } from "@/lib/types";
import { CloseButton } from "@/components/ui/close-button";

interface Props {
  task: Task | null;
  projectById: Map<string, any>;
  onClose: () => void;
}

function formatDate(date?: string | null) {
  return date
    ? new Date(date)
        .toLocaleDateString("en-US")
        .replace(/\//g, "-")
    : "-";
}

export default function TaskDetailDrawer({
  task,
  projectById,
  onClose,
}: Props) {
  const projectMeta =
    task?.project_id ? projectById.get(task.project_id) : undefined;

  return (
    <Dialog open={!!task} onOpenChange={onClose}>
      <DialogContent className="max-w-[500px] w-fit bg-transparent border-none p-0 [&>button]:hidden">
        {task && (
          <ModalPanel className="h-full rounded-3xl p-6">
            {/* Header */}
            <div className="flex items-center justify-between pb-3 mb-4 border-b border-purple-500/10">
              <DialogTitle className="text-purple-200 text-[18px] font-semibold">
                {task.title}
              </DialogTitle>

              <CloseButton onClick={onClose} />
            </div>

            {/* Metadata */}
            <div className="grid grid-cols-2 gap-x-10 gap-y-1 text-sm">
              {/* LEFT: Client / Location / Project / Created */}
              <div className="flex flex-col gap-3">
                <Info label="Client:" value={projectMeta?.client_name} />
                <Info label="Location:" value={projectMeta?.city} />
                <Info label="Project:" value={projectMeta?.project_name} />
                <Info
                  label="Task Created"
                  value={formatDate(task.created_at)}
                />
              </div>

              {/* RIGHT: Discipline / Type / Status */}
              <div className="flex flex-col gap-3">
                <Info label="Discipline:" value={task.discipline} />
                <Info label="Type:" value={task.task_type} />
                <Info label="Status:" value={task.status} />
                <Info label="Task Due:" value={formatDate(task.due_date)} />
              </div>
            </div>

            {/* Description */}
            <div className="flex flex-col gap-1 mt-3">
            <span className="text-[15px] uppercase tracking-wide text-purple-300">
                Description
            </span>
            <div className="rounded-md bg-window/60 px-3 py-2 text-purple-100 text-sm leading-snug whitespace-pre-wrap">
                {task.description || "No description"}
            </div>
            </div>
          </ModalPanel>
        )}
      </DialogContent>
    </Dialog>
  );
}

function Info({ label, value }: { label: string; value?: string }) {
  return (
    <div className="flex flex-col gap-1">
      <span
        className="
          text-[15px]
          uppercase
          tracking-wide
          text-purple-300
        "
      >
        {label}
      </span>

      <div
        className="
          rounded-md
          bg-window/60
          px-3
          py-1.5
          text-purple-100
          text-sm
          leading-snug
        "
      >
        {value || "-"}
      </div>
    </div>
  );
}


